export var ParameterFields;
(function (ParameterFields) {
    ParameterFields["id"] = "id";
    ParameterFields["parameter"] = "parameter";
    ParameterFields["name"] = "name";
    ParameterFields["type"] = "type";
    ParameterFields["units"] = "units";
    ParameterFields["min"] = "min";
    ParameterFields["max"] = "max";
    ParameterFields["granularity"] = "granularity";
    ParameterFields["flowIndexes"] = "flowIndexes";
})(ParameterFields || (ParameterFields = {}));
export var SelectParameterFields;
(function (SelectParameterFields) {
    SelectParameterFields["name"] = "name";
    SelectParameterFields["type"] = "type";
    SelectParameterFields["units"] = "units";
})(SelectParameterFields || (SelectParameterFields = {}));
export var SourceFields;
(function (SourceFields) {
    SourceFields["id"] = "id";
    SourceFields["type"] = "type";
    SourceFields["view"] = "view";
    SourceFields["source"] = "source";
    SourceFields["_variableName"] = "_variableName";
    SourceFields["variableType"] = "variableType";
    SourceFields["customVariableId"] = "customVariableId";
    SourceFields["units"] = "units";
    SourceFields["timing"] = "timing";
    SourceFields["colorProfile"] = "colorProfile";
    SourceFields["confidenceMin"] = "confidenceMin";
    SourceFields["confidenceMax"] = "confidenceMax";
    SourceFields["density"] = "density";
    SourceFields["simulation_id"] = "simulationId";
    SourceFields["adjustmentId"] = "adjustmentId";
    // insight source type
    SourceFields["insightId"] = "insightId";
    SourceFields["inputSetId"] = "inputSetId";
    SourceFields["outputId"] = "outputId";
    SourceFields["isFinal"] = "isFinal";
})(SourceFields || (SourceFields = {}));
export var SelectSourceFields;
(function (SelectSourceFields) {
    SelectSourceFields["type"] = "type";
    // simulation
    SelectSourceFields["simulation_id"] = "simulationId";
    SelectSourceFields["adjustment_id"] = "adjustmentId";
    // insight
    SelectSourceFields["insight_id"] = "insightId";
    SelectSourceFields["input_set_id"] = "inputSetId";
    SelectSourceFields["insight_output"] = "output";
})(SelectSourceFields || (SelectSourceFields = {}));
